/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : AuthButton.jsx
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */
/**
 * @author Narender - narender@au79consulting.com
 * @date 12-06-2024
 * @description Reusable button component for authentication related actions.
 */

import { Button } from "@mui/material";
import React from "react";
import appTheme from "../../assets/AppTheme/appTheme";

/**
 * @author : Narender - narender@au79consulting.com
 * @Date : 12-06-2024
 * @description Reusable button component for authentication related actions.
 * @param { type, btnName, handleOnClick }
 * @return The rendered button component.
 */
function AuthButton({ type, btnName, handleOnClick }) {
  return (
    <Button
      fullWidth
      type={type}
      variant="contained"
      sx={styles.btnStyle}
      onClick={handleOnClick}
    >
      {btnName}
    </Button>
  );
}

export default AuthButton;

// Styling for the AuthButton component
const styles = {
  btnStyle: {
    marginTop: 3,
    backgroundColor: "#2196F3",
    color: "#ffffff",
    textTransform: "none",
    ...appTheme.commonBtnStyle,
  },
};
